import React from 'react';
import { Box, Heading, Body, Button } from '@hover/blueprint';
import { Link } from 'gatsby';

const WantToPartner = () => (
  <Box
    flexDir="column"
    justifyContent="center"
    bgColor="neutral.50"
    alignItems="center"
    borderRadius={10}
    width=" 1100px"
    maxW="90%"
    py="80px"
    mx="50px"
    mb={10}
  >
    <Heading sx={{ mb: 7 }} size={600}>
      Want to partner with HOVER?
    </Heading>
    <Body mb={4}>Learn more about what a partnership would look like.</Body>
    <Button as={Link} to="/partnership-inquiry" size="large">
      Contact Us
    </Button>
  </Box>
);

export default WantToPartner;
